import { Component } from "@angular/core";

@Component({
  selector: "app-questionnaire-def-list-page",
  templateUrl: "./questionnaire-def-list-page.component.html",
  styleUrls: ["./questionnaire-def-list-page.component.scss"],
})
export class QuestionnaireDefListPageComponent {}
